import React from 'react';
import styles from './Card_members.module.scss';

interface CardMembersProps {
  name: string;
  role: string;
  expression: string;
  picture: string;
}

const Card_members: React.FC<CardMembersProps> = ({ name, role, expression, picture }) => {
  return (
    <div className={styles.card}>
      <img src={picture} alt={name} className={styles.picture} />
      <div className={styles.text}>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.role}>{role}</p>
        <p className={styles.expression}>"{expression}"</p>
      </div>
    </div>
  );
};

export { Card_members };